import * as _utils from '@/assets/js/Utilities';
import { EffectComposer } from "postprocessing";
import { FloatType, LinearSRGBColorSpace, WebGLRenderer } from "three";


export default class LutsPreview {
	constructor() {
		this.composers = ["empty"];
		this.renderer = new WebGLRenderer({
			powerPreference: "high-performance",
			antialias: false,
			stencil: false,
			depth: false,
			alpha: true,
		});
		this.renderer.outputColorSpace = LinearSRGBColorSpace;
		this.renderer.domElement.id = 'luts-preview-canvas';
		document.querySelector('#lut-previews-container').prepend(this.renderer.domElement);
		this.renderer.setClearColor(0x000000, 0);

		// this.renderer.setPixelRatio(window.devicePixelRatio);
		this.renderer.setScissorTest(true);

		this.renderer.domElement.addEventListener("webglcontextlost", function(event) {
			event.preventDefault();
			vm.$snackbar(`No WebGL available. Please reload the page and if the error persists, restart the browser.`, "error", {
				class: 'browser-crash-notice',
				timeout: -1,
			});

			setTimeout(() => {
				try {
					lutPreviewer.renderer.forceContextRestore();
				} catch(e) {
					//
				}
			}, 1000)
		});

		this.renderer.domElement.addEventListener("webglcontextrestored", function(event) {
			lutPreviewer.render();
		})
	}

	init() {
		UI.container.lutPreviews.off("scroll").on("scroll", () => this.render());
		this.setSize();

		this.updateSize();
	}

	getPreviewTemplate() {
		return document.getElementById("template").text;
	}

	createPreviews(dataArray, canRemove = false, omitIndex, blockCategory = false) {
		let content = document.getElementById("previews-list-container");

		dataArray.forEach((data, i) => {
			if (omitIndex == i) return;

			let element = document.createElement("div");
			element.className = `list-item thumbnail-canvas`;
			element.innerHTML = this.getPreviewTemplate().replace("Scene $", data.title);

			if (blockCategory == 'colourMatch' ||
				blockCategory == 'ColourMatchV2' ||
				blockCategory == 'AIColourExtract' ||
				blockCategory == 'AIColourExtractV2' ||
				blockCategory == 'AIColourMatch' ||
				blockCategory == 'AIColourMatchV2' ||
				['AIExposure', 'AIContrast', 'AIWhiteBalance'].includes(blockCategory)
			) element.querySelector('.preview-opacity-container').remove();

			element.addEventListener("click", e => {
				if (lutify.activeBefore && !lutify.bubbleMessage) UI.message.activate(UI.message.texts.inBeforeMode, "stay");
				if ($(e.currentTarget).find(".selected_thumbnail").length == 0) {
					if (blockCategory == 'colourMatch') {
						this.onColourMatchPreviewSelection($(e.currentTarget));

						let presetId = e.currentTarget.getAttribute('data-preset-id');
						let $block = $(UI.getActiveBlock());
						let preset = [..._Adjustments.colourMatch.initialPresets, ..._Adjustments.colourMatch.presets].find(preset => preset.id == presetId);

						_Adjustments.colourMatch.updatePresetList(preset.id, preset.name);
						_Adjustments.colourMatch.setBlockValues($block, preset);
						$(UI.getActiveBlock()).find('.btn-block-needs-update').addClass('hide');
					} else if (blockCategory == 'ColourMatchV2') {
						this.onColourMatchPreviewSelection($(e.currentTarget));

						let presetId = e.currentTarget.getAttribute('data-preset-id');
						let $block = $(UI.getActiveBlock());
						let preset = _Adjustments.ColourMatchV2.presets.find(preset => preset.id == presetId);

						_Adjustments.ColourMatchV2.setBlockValues($block, preset);
						_Adjustments.ColourMatchV2.updatePresetList(preset.id, preset.name);
					} else if (
						blockCategory == 'AIColourExtract' ||
						blockCategory == 'AIColourExtractV2' ||
						blockCategory == 'AIColourMatch' ||
						blockCategory == 'AIColourMatchV2'
					) {
						this.onColourMatchPreviewSelection($(e.currentTarget));

						let targetPassIndex = 2;
						if (blockCategory == 'AIColourMatchV2') targetPassIndex = 4;

						let presetId = e.currentTarget.getAttribute('data-preset-id');
						let $block = $(UI.getActiveBlock());

						let categoryName = blockCategory;
						if (categoryName == 'AIColourExtractV2') categoryName = 'AIColourExtract';
						if (categoryName == 'AIColourMatchV2') categoryName = 'AIColourMatch';

						let preset = luts['LUTcontrols'][`${categoryName}-${lutify.getActiveBlock().passes[targetPassIndex].uid}`].find(preset => preset.presetId == presetId);
						lutify.getActiveBlock().presetId = presetId;

						let $element = $(e.currentTarget);
						let composerIndex = $element.data("composer-index");

						this.applySpecificPreviewPass(composerIndex, 4);

						this.render();
						gpu.render();

						_Adjustments[blockCategory].updatePresetList(preset);
						$(UI.getActiveBlock()).find('.btn-block-needs-update').addClass('hide');
					} else if (data.category == 'NeuralToneAI') {
						this.onColourMatchPreviewSelection($(e.currentTarget));

						let presetId = e.currentTarget.getAttribute('data-preset-id');
						let preset = luts['LUTcontrols'][`NeuralToneAI`][presetId];
						lutify.getActiveBlock().presetId = presetId;

						_Adjustments.NeuralToneAI.onPresetSelection(preset);

						UI.setPreviewerOpacity(lutify.getActiveBlock().opacity);
					} else if (data.category == 'NeuralFilmAI') {
						this.onColourMatchPreviewSelection($(e.currentTarget));

						let presetId = e.currentTarget.getAttribute('data-preset-id');
						let preset = luts['LUTcontrols'][`NeuralFilmAI`][presetId];
						lutify.getActiveBlock().presetId = presetId;

						_Adjustments.NeuralFilmAI.onPresetSelection(preset);

						UI.setPreviewerOpacity(lutify.getActiveBlock().opacity);

						if (!lutify.getActiveBlock().values.enableGrain) {
							UI.getActiveBlock().find('[data-control="enable-grain"]').prop('checked', true).trigger('change');
						}
					} else {
						this.onPreviewSelection($(e.currentTarget));
					}
				}
			});

			element.querySelector(".scene").addEventListener("click", e => {
				if (lutify.activeBefore && !lutify.bubbleMessage) UI.message.activate(UI.message.texts.inBeforeMode, "stay");
				if ($(e.currentTarget).hasClass("selected_thumbnail")) {
					e.stopPropagation();
					this.onPreviewDeselection($(e.currentTarget).closest(".list-item"));
				}
			});

			let newComposerIndex = this.addComposer(element.querySelector(".scene"), data.category);
			data.composerIndex = newComposerIndex;

			if (canRemove) {
				let removeBtn = document.createElement("i");
				removeBtn.setAttribute("class", "btn-remove-custom-lut material-icons");
				removeBtn.setAttribute("data-tippy-content", "Remove LUT");
				removeBtn.innerHTML = "highlight_off";

				removeBtn.addEventListener("click", e => {
					e.stopPropagation();
					vm.$store.commit('UserFilesCustomLuts/SET_LUT_TO_DELETE', {
						id: data.lutId,
						name: data.title + '.123.cube' // needs refactoring, cause we use stripTimestampAndExtension in modal
					});

					if (lutify.getActiveBlock().name == "customLUT") {
						window.UI.showModal(window.UI.modals.customLUT.delete.el);
					} else {
						window.UI.showModal(window.UI.modals.customLutV2.delete.el);
					}
				});

				element.querySelector(".thumbnail-info").appendChild(removeBtn);
			}

			element.setAttribute("data-composer-index", newComposerIndex);
			element.setAttribute("data-lut-index", data.lutId ? data.lutId : i); // NOTE: can be refactored/removed
			element.setAttribute("data-category", data.category);
			element.setAttribute("data-control", data.control);
			element.setAttribute("data-name", data.title);
			if (data.opacity) element.setAttribute("data-opacity", data.opacity);
			element.setAttribute("style", "display: none;");

			if (blockCategory == 'colourMatch' ||
				blockCategory == 'ColourMatchV2' ||
				blockCategory == 'AIColourExtract' ||
				blockCategory == 'AIColourExtractV2' ||
				blockCategory == 'AIColourMatch' ||
				blockCategory == 'AIColourMatchV2'
			) {
				element.setAttribute("data-preset-id", data.presetId);
			}

			if (data.category == 'NeuralToneAI') {
				element.setAttribute("data-preset-id", i);
			}

			if (data.category == 'NeuralFilmAI') {
				element.setAttribute("data-preset-id", i);
			}

			if (data.category == 'AIMagicMode' ||
				['AIExposure', 'AIContrast', 'AIWhiteBalance'].includes(blockCategory)
			) {
				element.setAttribute("data-preset-id", i);
			}

			content.appendChild(element);
		});

		// Setting the size for the LUT preview placeholders
		UI.lutPreviewThumbnail.setSize(lutPreviewer.width, lutPreviewer.height);
		// this.updateSize();
	}

	createPlaceholderPreviews() {
		let $container = $("#previews-list-container");

		for (let i = 0; i < 5; i++) {
			let element = UI.createPlaceholder();
			$container.append(element);
		}
	}

	removePlaceholderPreviews() {
		$("#previews-list-container")
			.find(`.list-item[data-category="placeholder"]`)
			.remove();
	}

	showPlaceholderPreviews() {
		if (!lutify.applyingCandidate) {
			this.removePlaceholderPreviews();
			this.createPlaceholderPreviews();
			this.switchCanvases("placeholder");
			$("#luts-preview-canvas").addClass("hide");
		}
	}

	addComposer(targetElement, category = "lut") {
		let composer = new EffectComposer(this.renderer, {
			frameBufferType: FloatType,
		});
		this.updateSize();
		composer.targetElement = targetElement;
		composer.category = category;
		this.composers.push(composer);
		return this.composers.length - 1;
	}

	setSize() {
		let ratio = lutify.imageWidth / lutify.imageHeight;
		let previewWidth = UI.container.previewsSidebarContainer.width() - 30;
		let previewHeight = previewWidth / ratio;

		this.width = previewWidth;
		this.height = previewHeight;
	}

	updateSize() {
		if (typeof UI.lutsPreviewCanvas.el !== "undefined") {
			// let width = UI.lutsPreviewCanvas.el.clientWidth;
			// let height = UI.lutsPreviewCanvas.el.clientHeight;
			let width = window.innerWidth;
			let height = window.innerHeight;
			this.renderer.setSize(width, height);
		}
	}

	cloneMainComposerPasses() {
		this.composers.forEach(composer => {
			if (composer == "empty") return;

			composer.passes = [];
			lutify.blocks.forEach(block => {
				block.passes.forEach(pass => composer.passes.push(pass));
			});
		});
	}

	addPass(control, category, passIndexToSwap = 0, blendID = 0, blockCategory = null) {
		let passIdToSwap = lutify.getActiveBlock().passes[passIndexToSwap].uid;

		try {
			luts[control][category].forEach((LUT, i) => {
				let composerIndex = LUT.composerIndex;
				let pass = gpu.createLUTPass(LUT.texture);
				pass.name = LUT.title;
				pass.uid = passIdToSwap;

				if (lutify.getActiveBlock().name == "magicMode") {
					pass.uniforms.opacity.value = lutify.getActiveBlock().opacity[lutify.magicMode.activeStep] * 0.01;
				} else if (lutify.getActiveBlock().name == "AIMagicMode") {
					pass.uniforms.opacity.value = lutify.getActiveBlock().opacity[lutify.AIMagicMode.activeStep] * 0.01;
				} else if (pass.uniforms.opacity) {
					pass.uniforms.opacity.value = lutify.getActiveBlock().opacity * 0.01;
				}

				if (pass.uniforms.blendID) {
					pass.uniforms.blendID.value = blendID;
				}

				// first preset where no WB lut should be applied is disabled
				if (blockCategory == 'AIColourExtract' && i <= 1) {
					pass.enabled = false;
				}

				if ((blockCategory == 'AIColourExtractV2' || blockCategory == 'AIColourMatch' || blockCategory == 'AIColourMatchV2') && i == 0) {
					pass.enabled = false;
				}

				if (blockCategory == "NeuralFilmAI") {
					pass.enabled = lutify.getActiveBlock().values.enableColourGrade;
				}

				if (blockCategory == 'NeuralToneAI' ||
					blockCategory == "NeuralFilmAI"
				) {
					const modelPassIdToSwap = lutify.getActiveBlock().passes[passIndexToSwap - 1].uid;
					const modelLutPass = gpu.createLUTPass(lutify.getActiveBlock().predictions[i].texture);
					modelLutPass.name = `${blockCategory} model LUT`;
					modelLutPass.uid = modelPassIdToSwap;
					modelLutPass.uniforms.opacity.value = lutify.getActiveBlock().opacity * 0.01;

					if (blockCategory == 'NeuralFilmAI') {
						modelLutPass.enabled = lutify.getActiveBlock().values.enableColourGrade;
					}

					this.composers[composerIndex].passes.forEach((composerPass, j) => {
						if (composerPass.uid == modelPassIdToSwap) {
							this.composers[composerIndex].removePass(composerPass);
							this.composers[composerIndex].addPass(modelLutPass, j);
						}
					});
				}

				this.composers[composerIndex].passes.forEach((composerPass, j) => {
					if (composerPass.uid == passIdToSwap) {
						this.composers[composerIndex].removePass(composerPass);
						this.composers[composerIndex].addPass(pass, j);
					}
				});
			});
		} catch (error) {
			console.log(error);
		}
	}

	// NOTE: used by shadow/highlight tint - curve based
	addCurvePass(dataset) {
		let passIdToSwap = lutify.getActiveBlock().passes[0].uid;
		dataset.forEach((control, i) => {
			this.composers[control.composerIndex].passes.forEach((pass, j) => {
				if (pass.uid == passIdToSwap) {
					control.shaderPass.uid = passIdToSwap;
					this.composers[control.composerIndex].passes[j] = control.shaderPass;
				}
			});
		});
	}

	getPassIndexById(composer, uid) {
		let passIndex = null;
		composer.passes.forEach((pass, i) => {
			if (pass.uid == uid) passIndex = i;
		});

		return passIndex;
	}

	updateOpacity(opacityValue, targetPassIndex = 0) {
		let passNumber = this.getPassIndexById(gpu.composer, lutify.getActiveBlock().passes[targetPassIndex].uid);
		this.composers.forEach((composer, i) => {
			if (composer == "empty") return;
			if (!composer.passes[passNumber]?.uniforms?.opacity) return;

			composer.passes[passNumber].uniforms.opacity.value = opacityValue;
		});
	}

	//filtering thumbnails in right sidebar depending on which category is selected
	switchCanvases(category, isCustomLutBlock = false) {
		$("#previews-list-container .thumbnail-canvas").hide();

		if (isCustomLutBlock) {
			$(`#previews-list-container .thumbnail-canvas[data-control="customLUT"][data-category="${category}"]`).each(function() {
				$(this).show();
			});
		} else {
			$(`#previews-list-container .thumbnail-canvas[data-category="${category}"]`).each(function() {
				$(this).show();
			});
		}
	}

	render() {
		this.composers.forEach((composer, idx) => {
			if (composer == "empty") return;
			// if (idx > 1) return;
			if (composer.status !== "deleted") {
				// If the preview is not in the viewport, don't render it
				if (!$(composer.targetElement).is(":visible")) return;

				// get the placeholder DOM element for where to draw the scene
				let element = composer.targetElement;

				// get its position relative to the page's viewport
				let rect = element.getBoundingClientRect();

				// check if it's offscreen. If so skip it
				if (
					rect.bottom < 0 ||
					rect.top > this.renderer.domElement.clientHeight ||
					rect.right < 0 ||
					rect.left > this.renderer.domElement.clientWidth
				) {
					return;
				}

				// set the viewport
				let width = rect.width;
				let height = rect.height;
				let left = rect.left;
				let bottom = window.innerHeight - rect.bottom;

				this.renderer.setViewport(left, bottom, width, height);
				this.renderer.setScissor(left, bottom, width, height);

				composer.render();
			}
		});
	}

	onPreviewSelection($element) {
		UI.selectPreview($element);

		let name = $element.data("name");
		let composerIndex = $element.data("composer-index");
		let control = $element.data("control");
		let category = $element.data("category");
		// let filename = luts[control][category].filter(lut => lut.composerIndex == composerIndex).map(lut => lut.filename)[0];

		if (lutify.getActiveBlock().name == "magicMode") {
			lutify.getActiveBlock().selectedPreview[lutify.magicMode.activeStep] = composerIndex;
			lutify.getActiveBlock().selectedPreviewName[lutify.magicMode.activeStep] = name;

			$(`.magic-mode-controls-container i[data-step="${lutify.magicMode.activeStep}"]`).addClass("--applied");
			$(`#magic-mode-nav-container i[data-step="${lutify.magicMode.activeStep}"]`).addClass("--applied");
			_Adjustments.magicMode.updateLabel();
		} else if (lutify.getActiveBlock().name == "AIMagicMode") {
			lutify.getActiveBlock().selectedPreview[lutify.AIMagicMode.activeStep] = composerIndex;
			lutify.getActiveBlock().selectedPreviewName[lutify.AIMagicMode.activeStep] = name;

			$(`.magic-mode-controls-container i[data-step="${lutify.AIMagicMode.activeStep}"]`).addClass("--applied");
			$(`#magic-mode-nav-container i[data-step="${lutify.AIMagicMode.activeStep}"]`).addClass("--applied");
			_Adjustments.AIMagicMode.updateLabel();
		} else if (['AIExposure', 'AIContrast', 'AIWhiteBalance'].includes(lutify.getActiveBlock().name)) {
			lutify.getActiveBlock().selectedPreview = composerIndex;
			lutify.getActiveBlock().selectedPreviewName = name;
			_Adjustments[lutify.getActiveBlock().name].updateLabel();
		} else if (lutify.getActiveBlock().name == "customLUT" || lutify.getActiveBlock().name == "CustomLutV2") {
			UI.getActiveBlock().find(`.lut-selector__items-container [data-composer-index="${composerIndex}"]`).trigger('click');
		} else {
			lutify.getActiveBlock().selectedPreview = composerIndex;
			lutify.getActiveBlock().selectedPreviewName = name;

			_Adjustments.LUTcontrols.updateDropdownSelectionLabel();
			UI.getActiveBlock().find(".block-warn").remove();
		}

		lutify.getActiveBlock().selectedPreviewCategory = category;
		lutify.selectedPreviewCategory = category;

		// Activating the switch of the block if not yet activated
		UI.enabledBlockSwitch();

		this.applyPreviewPass(composerIndex);

		// Updating the slider opacity value in the LUT previewer
		if (lutify.getActiveBlock().name == "magicMode") UI.setPreviewerOpacity(lutify.getActiveBlock().opacity[lutify.magicMode.activeStep]);
		else if (lutify.getActiveBlock().name == "AIMagicMode") UI.setPreviewerOpacity(lutify.getActiveBlock().opacity[lutify.AIMagicMode.activeStep]);
		else UI.setPreviewerOpacity(lutify.getActiveBlock().opacity);

		this.render();
		gpu.render();
	}

	onColourMatchPreviewSelection($element) {
		UI.selectPreview($element);
		UI.enabledBlockSwitch();

		let composerIndex = $element.data("composer-index");
		this.applyPreviewPass(composerIndex);
		this.render();
		gpu.render();
	}

	applyPreviewPass(composerIndex) {
		let targetPassIndex = 0;
		if (lutify.getActiveBlock().name == "magicMode") targetPassIndex = lutify.magicMode.activeStep;
		if (lutify.getActiveBlock().name == "AIMagicMode") targetPassIndex = lutify.AIMagicMode.activeStep;
		if (lutify.getActiveBlock().name == "customLUT" || lutify.getActiveBlock().name == "CustomLutV2") targetPassIndex = 1;
		if (lutify.getActiveBlock().name == "AIColourExtract" ||
			lutify.getActiveBlock().name == "AIColourExtractV2" ||
			lutify.getActiveBlock().name == "AIColourMatch"
		) {
			targetPassIndex = 2
		}
		if (lutify.getActiveBlock().name == "AIColourMatchV2") {
			targetPassIndex = 4
		}
		if (lutify.getActiveBlock().name == "NeuralToneAI" ||
			lutify.getActiveBlock().name == "NeuralFilmAI"
		) {
			targetPassIndex = 5;
			this.applySpecificPreviewPass(composerIndex, targetPassIndex - 1);
		}

		this.applySpecificPreviewPass(composerIndex, targetPassIndex);
	}

	applySpecificPreviewPass(composerIndex, targetPassIndex, pass = null) {
		let sourcePassIndex = lutPreviewer.getPassIndexById(
			lutPreviewer.composers[composerIndex],
			lutify.getActiveBlock().passes[targetPassIndex].uid
		);

		if (pass) {
			lutify.getActiveBlock().passes[targetPassIndex] = pass;
			gpu.composer.passes[sourcePassIndex] = pass;
		} else {
			lutify.getActiveBlock().passes[targetPassIndex] = this.composers[composerIndex].passes[sourcePassIndex];
			gpu.composer.passes[sourcePassIndex] = lutify.getActiveBlock().passes[targetPassIndex];
		}

		gpu.render();
	}

	onPreviewDeselection($element) {
		if (lutify.getActiveBlock().name == "AIColourExtract" ||
			lutify.getActiveBlock().name == "AIColourExtractV2" ||
			lutify.getActiveBlock().name == "AIColourMatch" ||
			lutify.getActiveBlock().name == "AIColourMatchV2"
		) {
			return;
		}

		let composerIndex = $element.data("composer-index");
		UI.deselectPreview($element);

		if (lutify.getActiveBlock().name == "magicMode") {
			lutify.getActiveBlock().selectedPreview[lutify.magicMode.activeStep] = null;
			lutify.getActiveBlock().selectedPreviewName[lutify.magicMode.activeStep] = null;

			_Adjustments.magicMode.updateLabel();
			_Adjustments.magicMode.resetAppliedTabs();
		} else if (lutify.getActiveBlock().name == "AIMagicMode") {
			lutify.getActiveBlock().selectedPreview[lutify.AIMagicMode.activeStep] = null;
			lutify.getActiveBlock().selectedPreviewName[lutify.AIMagicMode.activeStep] = null;

			_Adjustments.AIMagicMode.updateLabel();
			_Adjustments.AIMagicMode.resetAppliedTabs();
		} else if (['AIExposure', 'AIContrast', 'AIWhiteBalance'].includes(lutify.getActiveBlock().name)) {
			lutify.getActiveBlock().selectedPreview = null;
			lutify.getActiveBlock().selectedPreviewName = null;

			_Adjustments[lutify.getActiveBlock().name].updateLabel();
		} else if (lutify.getActiveBlock().name == "NeuralToneAI") {
			lutify.getActiveBlock().presetId = null;
			_Adjustments.NeuralToneAI.onPresetSelection();
		} else if (lutify.getActiveBlock().name == "NeuralFilmAI") {
			lutify.getActiveBlock().presetId = null;
			_Adjustments.NeuralFilmAI.onPresetSelection();
		} else {
			lutify.getActiveBlock().selectedPreview = null;
			lutify.getActiveBlock().selectedPreviewName = null;

			_Adjustments.LUTcontrols.updateDropdownSelectionLabel();
		}

		this.removePreviewPass(composerIndex);

		this.render();
		gpu.render();
	}

	removeCustomLutPreview(lutId) {
		UI.container.lutPreviews.find(`.list-item[data-lut-index="${lutId}"]`).remove();
	}

	removePreviewPass(composerIndex) {
		let targetPassIndex = 0;
		if (lutify.getActiveBlock().name == "magicMode") targetPassIndex = lutify.magicMode.activeStep;
		if (lutify.getActiveBlock().name == "AIMagicMode") targetPassIndex = lutify.AIMagicMode.activeStep;
		if (lutify.getActiveBlock().name == "customLUT" || lutify.getActiveBlock().name == "CustomLutV2") targetPassIndex = 1;
		if (lutify.getActiveBlock().name == "AIColourExtract" ||
			lutify.getActiveBlock().name == "AIColourExtractV2" ||
			lutify.getActiveBlock().name == "AIColourMatch") {
			targetPassIndex = 2;
		}
		if (lutify.getActiveBlock().name == "AIColourMatchV2") {
			targetPassIndex = 4;
		}
		if (lutify.getActiveBlock().name == "NeuralToneAI" ||
			lutify.getActiveBlock().name == "NeuralFilmAI"
		) targetPassIndex = 5;

		let sourcePassIndex = lutPreviewer.getPassIndexById(
			lutPreviewer.composers[composerIndex],
			lutify.getActiveBlock().passes[targetPassIndex].uid
		);

		let pass = gpu.createCopyPass();
		pass.uid = this.composers[composerIndex].passes[sourcePassIndex].uid;

		lutify.getActiveBlock().passes[targetPassIndex] = pass;
		gpu.composer.passes[sourcePassIndex] = lutify.getActiveBlock().passes[targetPassIndex];

		if (lutify.getActiveBlock().name == "NeuralToneAI" ||
			lutify.getActiveBlock().name == "NeuralFilmAI"
		) {
			targetPassIndex = targetPassIndex - 1;

			sourcePassIndex = lutPreviewer.getPassIndexById(
				lutPreviewer.composers[composerIndex],
				lutify.getActiveBlock().passes[targetPassIndex].uid
			);

			pass = gpu.createCopyPass();
			pass.uid = this.composers[composerIndex].passes[sourcePassIndex].uid;

			lutify.getActiveBlock().passes[targetPassIndex] = pass;
			gpu.composer.passes[sourcePassIndex] = lutify.getActiveBlock().passes[targetPassIndex];
		}

		gpu.render();
	}

	sortPreviews(category, list) {
		_utils.sortAlphabetically(list, false).forEach((item, index) => {
			if (index == 0) return;

			let movingItem = UI.container.lutPreviews.find(`.list-item[data-category="${category}"][data-name="${item}"]`);
			let targetItem = UI.container.lutPreviews.find(`.list-item[data-category="${category}"][data-name="${list[index - 1]}"]`);
			targetItem.after(movingItem);
		});
	}
}
